import { colors } from '../../Colors/colors'

export const globalSearchTheme = {
   light: {
      searchIconColor: colors['gray-500'],
      searchModal: {
         escTextColor: 'text-gray-600',
         escBgColor: 'bg-gray-50',
         escBorderColor: 'border-gray-100',
         headerBorderColor: 'border-gray-200',
         retryIconColor: colors['gray-700'],
         noDataViewBgColor: '!bg-white',
         searchResultsHeadingColor: 'text-gray-600',
         searchResultItemHoverColor: 'hover:bg-gray-50',
         salesPipelinePickerTheme: {
            salesPipelineColor: 'text-gray-900',
            tickIconColor: colors['primary-600'],
            selectedSalesPipelineBgColor: 'bg-gray-50',
            customOptionHoverBgColor: ' hover:bg-gray-50'
         },
         salesTemplatePickerTheme: {
            salesTemplateColor: 'text-gray-900',
            tickIconColor: colors['primary-600'],
            selectedSalesTemplateBgColor: 'bg-gray-50',
            customOptionHoverBgColor: ' hover:bg-gray-50'
         },
         fieldSelectionPipeBgColor: 'bg-gray-300',
         gsFieldBorderColor: 'border-gray-300'
      }
   },
   dark: {}
}
